var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMapDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 97.917,
    viewBox: "0 0 100 97.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffb5b5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.062,25.72H77.8V14.833A13.972,13.972,0,0,0,63.857.72H37.585A13.971,13.971,0,0,0,23.637,14.833V25.72H13.376A12.425,12.425,0,0,0,.72,38.089V86.02A12.635,12.635,0,0,0,13.376,98.637H88.062A12.638,12.638,0,0,0,100.72,86.018V38.089A12.428,12.428,0,0,0,88.062,25.72ZM31.97,14.833a6.017,6.017,0,0,1,5.615-5.779H63.857a6.022,6.022,0,0,1,5.613,5.779V25.72H31.97ZM73.637,71.553H59.053V86.137H42.387V71.553H27.8V54.887H42.387V40.3H59.053V54.887H73.637Z",
    transform: "translate(-0.72 -0.72)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapDoctor);
export default __webpack_public_path__ + "static/media/icon-map-doctor.ac3ab6d4fdb0bb95f44f658278772220.svg";
export { ForwardRef as ReactComponent };